"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ARTICLE_BOX_SKELETON = void 0;
const ARTICLE_BOX_SKELETON = exports.ARTICLE_BOX_SKELETON = 'article-box-skeleton';
//# sourceMappingURL=constants.js.map